import baseService from './baseService';
import { HOST } from './../utils/config';
import colorApi from './color.js';

// 请求域名
const {ADDRESS, API, RealTime} = HOST;

class AssetInstitutionService extends baseService{
  // 获取标的-列表
  static getTargetAuctionList(params) {
    return colorApi('unifiedSearchWithCollapseProductsAndTops', {...params,pageViewSource: 'page_shop_m'})
  }

  // 获取折叠标的-列表
  static getCollapseAuctionList (params) {
    return colorApi('queryCollapseProducts',params)
    // return this.jsonpMethod(`${HOST.API}?appid=paimai&functionId=queryCollapseProducts&body=${JSON.stringify(params)}`)
  }

  // 获取推介-列表
  static getPromotionAuctionList(params) {
    return this.jsonpMethod(`${HOST.API}?appid=paimai&functionId=paimai_queryTopAnnouncements&body=${JSON.stringify(params)}`)
  }

  // 获取破产机构选聘-列表
  static getMechanismSelectionList(params) {
    return this.jsonpMethod(`//api.m.jd.com/api?appid=AuctionTreasure&functionId=listAnnouncementByCondi&body=${JSON.stringify(params)}`)
  }

  // 请求实时数据接口
  // 新实时数据接口: getPaimaiCurrentInfoByIdsForApi
  // 旧实时数据接口: queryPaimaiCurrentAndInfosByIds
  static realTimeRefresh (paimaiIds) {
    return colorApi('getPaimaiCurrentInfoByIdsForApi', {
      ids: paimaiIds,
      idTypeEnum: "PAIMAI_ID",
      idType: 0,
      clientInfo: {
        businessId: "shop_public",
      }
    })
    // return this.jsonpMethod(`${HOST.API}?appid=paimai&functionId=getPaimaiCurrentInfoByIdsForApi&body=${JSON.stringify({
    //   ids: paimaiIds,
    //   idTypeEnum: "PAIMAI_ID",
    //   idType: 0,
    //   clientInfo: {
    //     businessId: "shop_public",
    //   }
    // })}`)
  }

  // 请求机构中间页
  static getMiddleOrganizationList(params) {
    return this.jsonpMethod(`//api.m.jd.com/api?appid=paimai&functionId=getOrganizationIndexData&body=${JSON.stringify(params)}`)
  }

  // 请求二级机构
  static getSecondOrganizationList(params) {
    return this.jsonpMethod(`//api.m.jd.com/api?appid=paimai&functionId=getLevelOneData&body=${JSON.stringify(params)}`)
  }

  // 请求机构分类
  static getOrganizationType() {
    return this.jsonpMethod(`//api.m.jd.com/api?appid=paimai&functionId=getOrganizationTypeAndNameList&body={}`)
  }

  // 请求直播楼层数据
  static getLiveInfoByVendorId(params) {
    return this.jsonpMethod(`${HOST.API}api?appid=paimai&functionId=getLiveInfoByVendorId&body=${JSON.stringify(params)}`)
  }
}

export default AssetInstitutionService;

